import { IpAddressRepository } from "./IpAddressRepository";

const resource = "";

export default {
  getIpAddress() {
    return IpAddressRepository.get(`${resource}?format=json`);
  }
};
